import { routes } from "../helpers/constants";

export const dashboardOptions = [
  { title: "GOVERMENT", label: "LOCAL GOVERMENT", path: routes.goverment },
  { title: "COMPANY", label: "COMPANY", path: routes.company },
  { title: "REPORTS", label: "REPORTS", path: routes.reportsList },
];

export const reportListOptions = [
  {
    title: "gReports",
    label: "GOVERMENT REPORTS",
    path: routes.reports,
  },
  { title: "cReports", label: "COMPANY REPORTS", path: routes.reports },
];
